import styled from 'styled-components/macro';
import { FlexAlignCenter } from '../../../../shared-styles/flex';

export const TopNavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  height: 50px;
  background-color: ${(props) => props.theme.palette.darkBlue[100]};
  z-index: 1000;
`;

export const LeftNavDiv = styled.div`
  ${FlexAlignCenter}
`;

export const RightNavDiv = styled.div`
  ${FlexAlignCenter}
 `;

export const Logo = styled.img`
  height: 20px;
  width: 193px;
  margin-left: ${({ theme }) => theme.spacing(20)};
`;
